// import axios from "@assets/js/axios";
// const { instance: $axios } = axios;
const common = {
  state: {
    country: {
      hot: null,
      list: null,
      allData: null,
    },
  },
  getters: {
    getCountry (state) {
      return state.country;
    }
  },
  mutations: {
    setCountry (state, data) {
      state.country = data;
    }
  },
  actions: {},
};

export default common;